/* global axios */
import ApiClient from '../ApiClient';

class InstagramChannel extends ApiClient {
  constructor() {
    super('instagram', { accountScoped: true });
  }

  generateAuthorization(payload) {
    return axios.post(`${this.url}/authorization`, payload);
  }

  getServiceInfo(apiKey) {
    return axios.post(`${this.url}/authorization/service_info`, {
      api_key: apiKey,
    });
  }

  getAccounts(apiKey) {
    return axios.post(`${this.url}/authorization/accounts`, {
      api_key: apiKey,
    });
  }
}

export default new InstagramChannel();
